import Service from '../../Service';
import {http} from '../../config';

export default class MonitoramentoIndicadorService extends Service{

    constructor(){
        super('MonitoramentoIndicador');
    }

    ObterCompleto(Id, projetoId){
        return http.get(`${this.getNomeControle()}/${Id}/ObterItens/${projetoId}`);
    }

    AlterarItens(itemId, indicadorId, model){
        return http.put(`${this.getNomeControle()}/${indicadorId}/AlterarItem/${itemId}`, model);
    }

    EnviarDocumento(monitoramentoIndicadorId, monitoramentoIndicadorItemId, nome, arquivo){
        let bodyFormData = new FormData();
        bodyFormData.append('arquivo', new Blob([arquivo], { type: 'application/pdf' }));

        return http.post(`${this.getNomeControle()}/${monitoramentoIndicadorId}/documento`, bodyFormData, {
            headers: {'Content-Type': 'multipart/form-data' },
            params: {
                monitoramentoIndicadorItemId: monitoramentoIndicadorItemId,
                nome: nome
            }
        });
    }

    DownloadDocumento(monitoramentoIndicadorId, nome){
        return http.get(`${this.getNomeControle()}/${monitoramentoIndicadorId}/documento`, {
            responseType: 'blob',
            params: {
                nome: nome
            }
        }).then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nome);
            document.body.appendChild(link);
            link.click();
        });
    }

    DeletarDocumento(monitoramentoIndicadorId, monitoramentoIndicadorItemId, nome){
        return http.delete(`${this.getNomeControle()}/${monitoramentoIndicadorId}/documento`, {
            params: {
                monitoramentoIndicadorItemId: monitoramentoIndicadorItemId,
                nome: nome
            }
        });
    }
  
}